import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../../../../shared';
import { deletePortfolioTrades } from '../../../../services/portfolio';

const DeleteTradesModal = ({ open, closeModal, item: portfolio, setMessage }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const { t: translate } = useTranslation();

  const startForm = (bool) => {
    setLoading(bool);
    setDisabled(bool);
  };

  const errorMessage = (error) => {
    const response = error.response || error;
    switch (response.status) {
    case 403:
      setMessage(translate('permission denied'));
      break;
    default:
      setMessage(translate(`trades NOT deleted from portfolio`));
      break;
    }
  };

  const confirmDelete = async () => {
    startForm(true);

    try {
      await deletePortfolioTrades(portfolio.id);
      setMessage(translate(`trades deleted from portfolio`));
    } catch (err) {
      errorMessage(err);
    };

    startForm(false);
    closeModal();
  };

  return (
    <>
      <ConfirmationModal
        openModal={open}
        closeModal={() => closeModal()}
        testid='delete-trades-modal'
        name={translate('delete ALL trades from the portfolio?')}
        confirm={() => confirmDelete()}
        disabled={disabled}
        cancel='contained'
        loading={loading}
      />
    </>
  );
};

export default DeleteTradesModal;
